import { Shield } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useLanguage } from '@/i18n/LanguageContext';
import { lc } from '@/i18n/copy';

const copy = {
  en: {
    label: 'Sent by a Founding Member of Say It NOW',
    tooltip: 'This message comes from someone who supported Say It NOW from the beginning.',
  },
  es: {
    label: 'Enviado por un Miembro Fundador de Say It NOW',
    tooltip: 'Este mensaje proviene de alguien que apoyó Say It NOW desde el principio.',
  },
  fr: {
    label: 'Envoyé par un Membre Fondateur de Say It NOW',
    tooltip: 'Ce message vient de quelqu\'un qui a soutenu Say It NOW depuis le début.',
  },
  pt: {
    label: 'Enviado por um Membro Fundador do Say It NOW',
    tooltip: 'Esta mensagem vem de alguém que apoiou o Say It NOW desde o início.',
  },
  ar: {
    label: 'أُرسل بواسطة عضو مؤسس في Say It NOW',
    tooltip: 'هذه الرسالة من شخص دعم Say It NOW منذ البداية.',
  },
  ja: {
    label: 'Say It NOWの創設メンバーから送信',
    tooltip: 'このメッセージは、Say It NOWを最初からサポートしてくれた方からです。',
  },
  ko: {
    label: 'Say It NOW 창립 멤버가 보냄',
    tooltip: '이 메시지는 Say It NOW를 처음부터 지지해 주신 분의 것입니다.',
  },
  id: {
    label: 'Dikirim oleh Anggota Pendiri Say It NOW',
    tooltip: 'Pesan ini berasal dari seseorang yang mendukung Say It NOW sejak awal.',
  },

  hi: {
    label: 'Say It NOW के एक Founding Member द्वारा भेजा गया',
    tooltip: 'यह संदेश किसी ऐसे व्यक्ति से आया है जिसने शुरुआत से ही Say It NOW का समर्थन किया था।',
  },
};

export function FounderIndicator() {
  const { language } = useLanguage();
  const t = lc(copy, language);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center gap-1.5 text-xs text-primary/70 cursor-default select-none font-medium">
            <Shield className="h-3.5 w-3.5" />
            {t.label}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-xs max-w-[220px]">{t.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
